module.exports = __webpack_public_path__ + "media/images/sp/stores/shibuya/main-visual-text-872c917c5fe479d04eaa5821179969e2.png";